import { useEffect, useState } from "react";
import ConfirmModal from "./ConfirmModal";
import CommonModal from "./DumpModal";
import InputField from "./InputField";
import { useUserInfo } from "../../../../../context/user";
import { useSubmitOnboarding } from "../../../../../queries/settingsAccount";

const TellUsMoreModal = ({
  isOpen,
  onClose,
  setModal,
  currentSource,
}) => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newField, setNewFields] = useState({
    "Who are you?": "",
    "What are you all about?": "",
    "What can we help you achieve with AI?": "",
  });
  const userActiveLocation = useUserInfo()[4];
  const submitOnboarding = useSubmitOnboarding(userActiveLocation.id);

  useEffect(() => {
    if (!currentSource?.website_url && !currentSource?.file_name) {
      let formVals = {};
      currentSource?.form?.forEach((item) => {
        formVals = { ...formVals, [item.label]: item.value };
      });
      setNewFields(formVals);
    }
  }, [currentSource]);

  const handleConfirmModal = () => {
    setOpenConfirmModal(!openConfirmModal);
    setModal(false);
  };

  const handleConfirmClick = async () => {
    setLoading(true);
    try {
      const form = Object.keys(newField).map((item) => ({
        label: item,
        value: newField[item],
      }));
      const response = await submitOnboarding.mutateAsync({
        form: form,
        profileId: userActiveLocation.id,
        username: userActiveLocation.business_name,
      });
      if (response) {
        setOpenConfirmModal(false);
      }
    } catch (err) {
      alert(err.message);
      console.log(err);
    }
    setLoading(false);
  };

  const handleFieldChange = (e) => {
    setNewFields({ ...newField, [e.target.name]: e.target.value });
  };
  return (
    <>
      <CommonModal onClose={onClose} isOpen={isOpen} title="Tell us more">
        <div className="mt-4">
          <div className="flex flex-col mt-4">
            <label htmlFor="who-u-r" className="text-muted-foreground text-md">
              Who are you?
            </label>
            <textarea
              id="who-u-r"
              value={newField["Who are you?"]}
              placeholder="Tell us what makes you or your business tick, sparkle—or occasionally grumble. What’s your superpower?"
              onChange={handleFieldChange}
              name={"Who are you?"}
              className="border !border-border rounded-md px-2.5 py-2 outline-none resize-none"
              rows={2}
            />

            <div className="flex flex-col mt-4">
              <label htmlFor="what-r-u" className="text-muted-foreground text-md">
                What are you all about?
              </label>
              <textarea
                id="what-r-u"
                value={newField["What are you all about?"]}
                placeholder="Help the AI get to know you! What’s your mission, what problems do you solve, and what gets you excited (besides Fridays)? No elevator pitch needed—just be you."
                onChange={handleFieldChange}
                name={"What are you all about?"}
                className="border !border-border rounded-md px-2.5 py-2 outline-none resize-none"
                rows={5}
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="Ai" className="text-muted-foreground text-md">
                What can we help you achieve with AI?
              </label>
              <textarea
                id="Ai"
                value={newField["What can we help you achieve with AI?"]}
                placeholder="What does success look like for you? Whether it’s saving time, scaling up, or solving a specific challenge, tell us your goals so we can tailor AI to help."
                onChange={handleFieldChange}
                name={"What can we help you achieve with AI?"}
                className="border !border-border rounded-md px-2.5 py-2 outline-none resize-none"
                rows={3}
              />
            </div>
            <button
              className={`mt-4 text-center w-full rounded-md py-3 text-lg bg-primary text-primary-foreground `}
              onClick={handleConfirmModal}
            >
              Edit
            </button>
          </div>
        </div>
      </CommonModal>
      <ConfirmModal
        isOpen={openConfirmModal}
        onClose={handleConfirmModal}
        title="Confirm Changes"
        onConfirm={handleConfirmClick}
        loading={loading}
      />
    </>
  );
};

export default TellUsMoreModal;
